import React, { useEffect, useState } from 'react';
import CheckboxInput from './checkbox-input';

interface ICheckboxItem {
    label: string;
    name: string;
    value: string | number | string[];
}

interface ICheckboxListProps {
    name: string;
    english?: string;
    checkedItems: any[];
    items: ICheckboxItem[];
    onChange: (event: any) => void;
    disabled?: boolean;
}

const CheckboxList = ({
    name,
    english,
    checkedItems,
    items,
    onChange,
    disabled,
}: ICheckboxListProps) => {
    const [checkedItemsState, setCheckedItemsState] = useState<any[]>([]);

    useEffect(() => {
        setCheckedItemsState(checkedItems);
    }, [checkedItems && checkedItems.length]);

    const handleChange = (event: any) => {
        const { value, checked } = event.target;
        let values = [];

        if (checked) {
            values = [...checkedItemsState, value];
        } else {
            values = checkedItemsState.filter((x) => x !== value);
        }

        onChange({ target: { name, english, value: values } });
    };

    return (
        <>
            {items.map((item: ICheckboxItem, i) => {
                return (
                    <CheckboxInput
                        key={i}
                        label={item.label}
                        name={item.name}
                        value={item.value}
                        checked={
                            checkedItemsState &&
                            checkedItemsState.find((x) => x === item.value) !==
                                null
                        }
                        onChange={handleChange}
                        disabled={disabled}
                    />
                );
            })}
        </>
    );
};

export default CheckboxList;
